// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2DkCN","notes":"Notes_notes__1BoN9","note":"Notes_note__2-Nr3","markdown":"Notes_markdown__2bGTd"};